import { render, staticRenderFns } from "./loginbook.vue?vue&type=template&id=1ffa3ab7"
import script from "./loginbook.vue?vue&type=script&lang=js"
export * from "./loginbook.vue?vue&type=script&lang=js"
import style0 from "./loginbook.vue?vue&type=style&index=0&id=1ffa3ab7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports